export default "__VITE_ASSET__4789a4dd__"